import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter, NavLink } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../../../utils/global'
import { escapeHtml } from '../../../../utils/textFunctions'
import '../../../../styles/assets/css/admin/form3.css'
import { loadLocationWithMessage } from '../../../../actions/location'

import WarningIcon from '@material-ui/icons/Warning'

import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import PatientHead3 from "../../patient/patient_head3"
import 'react-quill/dist/quill.snow.css'

class EditResource extends Component {
  constructor() {
      super()
      this.quill = require('react-quill')
      this.state = {
          status: false,
          status_submit: true,
          message: '',
          name: '',
          url: '',
          free: 0,
          cost: '',
          description: '',
          category: 1,
          dataList: [],
          editMode: false,
      }
  }

  componentDidMount() {
    this.getData()
  }

  getData = () => {
    axios({
      method: 'post',
      url: connectNode + 'admin/worksheets/get_resource_w_edit',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: { sg_id: this.props.match.params.sg_id, category: 1, }
    })
    .then((result) => {
      console.log(result['data'])
      if(result['data']) {
        this.setState({
          uid: this.props.authReducer.uid,
          name: result['data'].name,
          url: result['data'].url,
          free: result['data'].free,
          cost: result['data'].cost,
          description: result['data'].description,
          category: result['data'].category_id,
        })
      }
    })
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleChange2 = (e, name) => {
    this.setState({
      [name]: e,
    })
  }

  handleChange7 = (e) => {
    var val = 0
    if (e.target.checked) {
      val = 1
    }
    this.setState({
      [e.target.name]: val,
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    if(this.state.url == '' || this.state.category == 0 || this.state.name.trim() == '') {
      this.setState({
        msg_status: false,
        message: 'Please fill in all information',
      })
    } else {
      axios({
        method: 'post',
        url: connectNode + 'admin/worksheets/edit_resource',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        },
        data: {
          uid: this.props.authReducer.uid,
          sg_id: this.props.match.params.sg_id,
          name: this.state.name,
          url: this.state.url,
          category: this.state.category,
          free: this.state.free,
          cost: this.state.cost,
          description: this.state.description,
        }
      })
      .then((result) => {
        if(result['data'] == this.props.match.params.sg_id) {
          this.props.onLoadLocation('/admin/worksheets/resources_list', 'Resource updated!')
          this.props.history.push('/admin/worksheets/resources_list')
        } else {
          this.setState({
            msg_status: false,
            message: 'Something went wrong. Please try again.',
          })
        }
        window.scrollTo(0, 0)
      })
    }
  }

  render() {
    //console.log(this.state)
    const ReactQuill = this.quill
    return (
      <div className="admin_log_outcome box_border4">
        <div className="row">
          <div className="small-12 columns headerPage1">
            Update Self-Guided Program
          </div>
        </div>
        <div className="row">
          <div className="small-12 columns ">
            { this.state.message !== '' &&
            <div className={(this.state.msg_status && "row warning_msg7") || (!this.state.msg_status && "row warning_msg6")}>
              <div className="small-12 columns ">
                <div className="float_left1"><WarningIcon /></div>
                <div className="txt_warning_msg1">{ this.state.message }</div>
              </div>
            </div>}
            <div className="box_border5">
              <form id="new_self_stigma" onSubmit={this.handleSubmit}>
                <div className="row">
                {(!this.state.editMode) &&
                <div>
                  <div className="small-12 columns box_inner2 top_space1">
                    <div className="row">
                      <div className="small-12 medium-2 columns bold_txt3">Name:</div>
                      <div className="small-12 medium-8 columns no_padding_left_float_left">
                      <TextField id="name" label="" onChange={this.handleChange}
                        variant="outlined" type="text" defaultValue={this.state.name}
                        value={this.state.name} InputProps={{ inputProps: { name: "name" }}} />
                      </div>
                    </div>
                    <div className="row top_space1">
                      <div className="small-12 medium-2 columns bold_txt3">Link:</div>
                      <div className="small-12 medium-8 columns no_padding_left_float_left">
                      <TextField id="url" label="" onChange={this.handleChange} value={this.state.url}
                        variant="outlined" type="text" defaultValue={this.state.url}
                        InputProps={{ inputProps: { name: "url" }}} />
                      </div>
                    </div>
                    <div className="row top_space1">
                      <div className="small-12 medium-2 columns bold_txt3">
                        <div className="no_top_space1">Cost:</div>
                      </div>
                      <div className="small-12 medium-8 columns no_padding_left_float_left">
                      <input type="checkbox" value="1" name="free"
                        checked={this.state.free} className="no_margin_bottom1"
                        onChange={(e) => this.handleChange7(e)} /> Free to download/use<br />
                        {this.state.free == 0 &&
                        <TextField id="cost" label="" onChange={this.handleChange} value={this.state.cost}
                        variant="outlined" type="text" defaultValue={this.state.cost}
                        InputProps={{ inputProps: { name: "cost", placeholder: "Cost information" }}} />}
                      </div>
                    </div>
                    <div className="row top_space1">
                      <div className="small-12 medium-2 columns bold_txt3">Description:</div>
                      <div className="small-12 medium-8 columns no_padding_left_float_left">
                      <ReactQuill name="description" modules={{toolbar: false}}
                        theme='snow' value={this.state.description}
                        onChange={(e) => this.handleChange2(e, 'description')}
                        style={{height: '200px'}} />
                      </div>
                    </div>
                  </div>
                </div>}
                </div>

                <div className="row top_space1">
                  <div className="small-12 columns text_align_right">
                  {this.state.dataList.length > 0 && !this.state.editMode &&
                    <a onClick={() => this.props.history.goBack()} className="go_back">Go Back</a>
                  }
                  {(this.state.dataList.length == 0 || this.state.editMode) &&
                    <span>
                    {this.state.status_submit &&
                    <Button variant="contained" color="primary" disableElevation
                     onClick={this.handleSubmit} type="submit">
                      Submit
                    </Button>}
                    {!this.state.status_submit &&
                    <Button variant="contained" disabled
                     onClick={this.handleSubmit} type="submit">
                      Submit
                    </Button>}
                    </span>}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  //console.log('AddPatient STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('AddPatient mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(EditResource)
